import { render } from "./swedbank-main.vue?vue&type=template&id=377e1d2e&scoped=true"
import script from "./swedbank-main.vue?vue&type=script&lang=js"
export * from "./swedbank-main.vue?vue&type=script&lang=js"

import "./swedbank-main.vue?vue&type=style&index=0&id=377e1d2e&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377e1d2e"]])

export default __exports__